<script setup lang="ts">
/**
 * `/models` — public model catalogue. Reuses the live `ModelsPricingTab`
 * (fetches `/v1/models` + `/api/models/capabilities` + `/api/pricing`, all
 * public on the router origin) inside the marketing layout.
 */
import ModelsPricingTab from '../components/docs/ModelsPricingTab.vue';
</script>

<template>
  <div class="max-w-6xl mx-auto w-full px-6 lg:px-10 py-12 lg:py-section flex flex-col gap-8">
    <header class="max-w-2xl">
      <p class="text-xs font-mono uppercase tracking-[0.2em] text-mute mb-3">Model catalogue</p>
      <h1 class="font-display text-3xl sm:text-4xl font-semibold tracking-tight">Every model on the network.</h1>
      <p class="text-body mt-3">
        Each model here is registered on the Gonka chain; capabilities and prices refresh in real
        time. Look around without an account — create a key when you want to call one.
      </p>
    </header>

    <ModelsPricingTab />

    <div class="flex flex-wrap items-center gap-3 pt-2">
      <RouterLink to="/login" class="btn-primary">Get API key</RouterLink>
      <RouterLink to="/docs" class="btn-secondary">Open the docs</RouterLink>
    </div>
  </div>
</template>
